module.exports = "https://trybtryb-legacy.web.app/img/shield.adba5b5e.svg";